export default class ImagesEntity  {
    image_id!: number
    page_id!: number;
    title!: string;
    image_url!: string;
    thumb_url!: string;
    no!: number;
    file!: any;
}